module.exports = __webpack_public_path__ + "media/images/emblems/Schlieren-blazon-ce0b72d809db211299169f26ea12f189.svg";